import useIntersectionObserver from '@/hooks/useIntersectionObserver';
import { RefObject, useEffect, useRef } from 'react';

const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export const useIsInView = (targetRef: RefObject<HTMLElement>) => {
  const refPosition = useIntersectionObserver(targetRef, { root: null, threshold: 0.3 });
  const isInView = refPosition === 'inView';
  const wasInView = usePrevious(isInView);

  return !wasInView && isInView;
};
